import { atom } from 'jotai';

import type { FolderCrumb, FolderNode } from '../types/fileSystem.js';

export const folderPathAtom = atom<FolderCrumb[]>([]);

export const draftFoldersAtom = atom<FolderNode[]>([]);

// FYI: documents come back from the API with no notion of a parent folder, so
// containment is kept here. A file missing from the map sits in the root.
export const fileLocationsAtom = atom<Record<string, string>>({});
